// Copyright (c) 2026 by Audere

import "./index.css";

import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { persistor, store } from "./app/features/store";

import { CssBaseline } from "@mui/material";
import ErrorPage from "./app/screens/ErrorPage";
import Home from "./app/screens/Home";
import Login from "./app/screens/Login";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom/client";
import RequireAuth from "./app/components/RequireAuth";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";

const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        element: <RequireAuth />,
        children: [
          {
            path: "home",
            element: <Home />,
          },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
